import {
  updateMediaOldArticle,
  initBlogVideos,
} from "../updateMediaOldArticle.js";
import StickySidebar from "../stickySidebar.js";
import ArticleNavigation from "../articleNavigation.js";
import ArticleNextObserver from "../articleNextObserver.js";
import { changeMediaListener } from "../changeMediaListener.js";
import { initUpdateRating } from "../initUpdateRating.js";
import { initAccordion } from "../../utils-shared/accordion.js";
import { initPopup } from "../../utils-shared/popup.js";
import { initArticleProgressBar } from "../articleProgressBar.js";
import { initArticleAudio } from "../articleAudio.js";
import { initAudioPlayer } from "../audioPlayer.js";

updateMediaOldArticle();

window.addEventListener("load", function () {
  changeMedia();
  initBlogVideos();
  initPopup();
  initUpdateRating();
  initAccordion();
  initArticleProgressBar();
  initArticleAudio();
  initAudioPlayer();
});

function changeMedia() {
  let sticky = null;
  let next = null;
  let articleNavigation = null;
  const isContentExist = Boolean(document.querySelector(".contents-menu"));

  const initNavigation = () => {
    if (isContentExist && !articleNavigation) {
      articleNavigation = new ArticleNavigation({});
    }
  };

  const phoneAndTabletHandler = () => {
    if (sticky) {
      sticky.destroy();
      sticky = null;
    }

    initNavigation();
    articleNavigation?.destroyDesktopListeners();

    if (next) {
      next.destroy();
      next = null;
    }
  };

  const desktopHandler = () => {
    initNavigation();
    articleNavigation?.initDesktopListeners();

    if (!next) next = new ArticleNextObserver(".js-sidebar-nav");
  };

  const desktopLowHandler = () => {
    if (sticky) {
      sticky.destroy();
      sticky = null;
    }

    sticky = new StickySidebar(".fixed-panel-inner", ".js-not-sticky");
  };

  const desktopHighHandler = () => {
    if (sticky) {
      sticky.destroy();
      sticky = null;
    }

    sticky = new StickySidebar(".fixed-panel-inner");
  };

  const customSizes = [
    {
      handler: () => desktopLowHandler(),
      query: "(min-width: 1024px) and (max-height: 890px)",
    },
    {
      handler: () => desktopHighHandler(),
      query: "(min-width: 1024px) and (min-height: 891px)",
    },
  ];

  changeMediaListener({
    phoneAndTabletHandler,
    desktopHandler,
    customSizes,
  });
}
